const forgotCredential = state => {
  return state.common.forgotCredential ?? ''
}

export { forgotCredential }
